var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 11C16.9853 11 19 8.98528 19 6.5C19 4.01472 16.9853 2 14.5 2C12.0147 2 10 4.01472 10 6.5C10 8.98528 12.0147 11 14.5 11ZM12.5744 4.57437C12.7341 4.41461 12.9931 4.41461 13.1529 4.57437L14.5 5.92146L15.8471 4.57437C16.0069 4.41461 16.2659 4.41461 16.4256 4.57437C16.5854 4.73413 16.5854 4.99315 16.4256 5.15291L15.0785 6.5L16.4256 7.84709C16.5854 8.00685 16.5854 8.26587 16.4256 8.42563C16.2659 8.58539 16.0069 8.58539 15.8471 8.42563L14.5 7.07854L13.1529 8.42563C12.9931 8.58539 12.7341 8.58539 12.5744 8.42563C12.4146 8.26587 12.4146 8.00685 12.5744 7.84709L13.9215 6.5L12.5744 5.15291C12.4146 4.99315 12.4146 4.73413 12.5744 4.57437ZM4.5 6H9.02242C9.00758 6.16468 9 6.33146 9 6.5C9 6.66854 9.00758 6.83532 9.02242 7H4.5C4.22386 7 4 6.77614 4 6.5C4 6.25454 4.17688 6.05039 4.41012 6.00806L4.5 6ZM6.5 10H10.2572C10.5705 10.3794 10.9338 10.7161 11.3369 11H6.5C6.22386 11 6 10.7761 6 10.5C6 10.2545 6.17688 10.0504 6.41012 10.0081L6.5 10ZM8.5 14H13.5C13.7761 14 14 14.2239 14 14.5C14 14.7455 13.8231 14.9496 13.5899 14.9919L13.5 15H8.5C8.22386 15 8 14.7761 8 14.5C8 14.2545 8.17688 14.0504 8.41012 14.0081L8.5 14Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clearFilter.352e7089316f0093519a1d323462236c.svg";
export { ForwardRef as ReactComponent };